module.exports = __webpack_public_path__ + "media/Video 104.ff753cde.mp4";